module.exports = __webpack_public_path__ + "img/icon-no-auth.2f82a81e.png";